import { d as o } from "./index-6a632112.mjs";
import "react";
const s = o`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  sup {
    line-height: 0;
  }

  @font-face {
    font-family: 'Inter', sans-serif;
    src: url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500&display=swap');
  }

  @font-face {
    font-family: 'FordAntenna', Arial, Helvetica, sans-serif;;
    font-weight: 500;
    src: url("https://cxc-assets.fordpro.com/fonts/ford/antenna-light.woff2") format("woff2"), url("https://cxc-assets.fordpro.com/fonts/ford/antenna-light.woff") format("woff");
  }
`;
export {
  s as GlobalStyles
};
